import Dropdown, { Option } from "@/ui/components/Dropdown"

import { useMemo, type FC } from "react"
import type { IFullCompanyDto } from "@/types/company/IFullCompanyDto"
import type { SingleValue } from "react-select"

import style from "../../style.module.scss"

type Props = {
  isLoading: boolean
  company: IFullCompanyDto | null
  companies: IFullCompanyDto[]
  changeCompany: (value: string) => void
}

export const BalancePickCompany: FC<Props> = ({ changeCompany, companies, company, isLoading }) => {
  const companyOptions = useMemo(() => {
    return companies.map(el => ({
      value: String(el.id),
      label: el.name
    }))
  }, [companies])

  const selectedOption = useMemo(() => {
    if (!company) {
      return null
    }

    return {
      value: String(company.id),
      label: company.name
    }
  }, [company])

  const handleChangeCampaign = (option: SingleValue<Option>) => {
    changeCompany(String(option?.value))
  }

  return (
    <div className={style.pickCompany}>
      <Dropdown
        options={companyOptions}
        value={selectedOption}
        label="Выберите компанию"
        onChange={handleChangeCampaign}
        searchable
        loading={isLoading}
      />
    </div>
  )
}
